document.addEventListener('DOMContentLoaded', function () {

    const nav = document.querySelector('.faq-nav');

    if (!nav) return;

    const categories = document.querySelectorAll('.faq-category');

    // Build sidebar menu
    categories.forEach((category, index) => {

        const title = category.querySelector('.faq-category-title');

        if (!title) return;

        const id = 'faq-section-' + index;

        category.id = id;

        const li = document.createElement('li');

        li.innerHTML = `
            <a href="#${id}" class="faq-nav-link">
                ${title.textContent.trim()}
            </a>
        `;

        nav.appendChild(li);

    });

    // Smooth scroll
    document.querySelectorAll('.faq-nav-link').forEach(link => {

        link.addEventListener('click', function(e){

            e.preventDefault();

            const target = document.querySelector(
                this.getAttribute('href')
            );

            if(target){

                window.scrollTo({
                    top: target.offsetTop - 120,
                    behavior: 'smooth'
                });

            }

        });

    });

    // Active menu
    const sections = document.querySelectorAll('.faq-category');
    const links = document.querySelectorAll('.faq-nav-link');

    window.addEventListener('scroll', function(){

        let current = '';

        sections.forEach(section => {

            const top = section.offsetTop - 200;

            if(window.pageYOffset >= top){
                current = section.id;
            }

        });

        links.forEach(link => {

            link.classList.remove('active');

            if(link.getAttribute('href') === '#' + current){
                link.classList.add('active');
            }

        });

    });


});

/*Jess edits to formatting*/

setTimeout(function () {
  document.querySelectorAll(".soda-card__description").forEach(function (el) {
    const parts = el.textContent.trim().split("\n").map(s => s.trim()).filter(Boolean);
    if (parts.length >= 2) {
      el.innerHTML = `<p>${parts[0]}</p><i><p style="font-size: 0.8em;">${parts[parts.length - 1]}</i></p>`;
    }
  });
}, 300);

setTimeout(function() {
  document.querySelectorAll('.soda-card__title').forEach(function(el) {
    if (el.textContent.trim() === 'Guava Glow') {
      el.innerHTML = 'Guava<br>Glow';
    }
  });
}, 300);

/*jess edits to pdp prices*/
// Pack size boxes: show autoship price + one-time price (discount read dynamically)
// (function () {
//   function updatePackBoxes(variantPriceMap) {
//     document.querySelectorAll('.variant-option__button-label').forEach(label => {
//       const input = label.querySelector('input[type="radio"]');
//       const prices = variantPriceMap[parseInt(input?.dataset.variantId)];
//       if (!prices) return;

//       const textSpan = label.querySelector('.variant-option__button-label__text');
//       const priceSpan = textSpan?.querySelector('.variant-price');
//       const oneTimeSpan = textSpan?.querySelector('span:not(.variant-price)');

//       if (priceSpan) priceSpan.style.display = 'none';

//       let autoshipLine = textSpan.querySelector('.brightside-autoship-label');
//       if (!autoshipLine) {
//         autoshipLine = document.createElement('span');
//         autoshipLine.className = 'brightside-autoship-label';
//         autoshipLine.style.cssText = 'display:none; font-weight:bold;';
//         priceSpan.insertAdjacentElement('afterend', autoshipLine);
//       }
//       autoshipLine.textContent = prices.autoship;

//       if (oneTimeSpan) oneTimeSpan.textContent = 'One-Time: ' + prices.oneTime;
//     });
//   }

  // async function init() {
  //   const resp = await fetch(window.location.pathname + '.js');
  //   const product = await resp.json();
  //   if (!product.selling_plan_groups?.length) return;

  //   const firstAdj = product.selling_plan_groups[0]
  //     ?.selling_plans[0]
  //     ?.price_adjustments
  //     ?.find(adj => adj.order_count === 1);
  //   if (!firstAdj) return;

  //   const fmt = (cents) => '$' + (cents / 100).toFixed(2);
  //   const calcAutoship = (price) => {
  //     if (firstAdj.value_type === 'percentage') return Math.round(price * (1 - firstAdj.value / 100));
  //     if (firstAdj.value_type === 'fixed_amount') return price - firstAdj.value;
  //     if (firstAdj.value_type === 'price') return firstAdj.value;
  //     return price;
  //   };

  //   const variantPriceMap = {};
  //   product.variants.forEach(v => {
  //     variantPriceMap[v.id] = { oneTime: fmt(v.price), autoship: fmt(calcAutoship(v.price)) };
  //   });

    // If buttons already exist, run immediately
    // if (document.querySelector('.variant-option__button-label')) {
    //   updatePackBoxes(variantPriceMap);
    //   return;
    // }

    // Otherwise wait for them to appear via MutationObserver
//     const observer = new MutationObserver(() => {
//       if (document.querySelector('.variant-option__button-label')) {
//         observer.disconnect();
//         updatePackBoxes(variantPriceMap);
//       }
//     });
//     observer.observe(document.body, { childList: true, subtree: true });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
// })();

// Always show autoship dropdown and benefits
(function () {
  function keepDropdownVisible() {
    const dropdown = document.querySelector('.brightside-frequency-dropdown-wrap');
    if (dropdown) dropdown.style.removeProperty('display');
  }

  const observer = new MutationObserver(keepDropdownVisible);

  function init() {
    const dropdown = document.querySelector('.brightside-frequency-dropdown-wrap');
    if (dropdown) {
      keepDropdownVisible();
      observer.observe(dropdown, { attributes: true, attributeFilter: ['style'] });
      return;
    }
    // Wait for it to appear
    const bodyObserver = new MutationObserver(() => {
      const dropdown = document.querySelector('.brightside-frequency-dropdown-wrap');
      if (dropdown) {
        bodyObserver.disconnect();
        keepDropdownVisible();
        observer.observe(dropdown, { attributes: true, attributeFilter: ['style'] });
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Rename "Auto + Ship" to "Autoship"
(function () {
  function renameAutoship() {
    const el = [...document.querySelectorAll('.brightside-purchase-option__title')]
      .find(el => el.textContent.trim() === 'Auto + Ship');
    if (el) el.textContent = 'Autoship + Save';
  }

  const observer = new MutationObserver(renameAutoship);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      renameAutoship();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    renameAutoship();
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

// Jess edits

(function () {
  function renameAutoship() {
    // Product page plan selector
    document.querySelectorAll('.brightside-purchase-option__title').forEach(el => {
      if (el.textContent.trim() === 'Auto + Ship') el.textContent = 'Autoship + Save';
    });

    // Cart drawer subscription label
    document.querySelectorAll('.brightside-cart-subscription-label').forEach(el => {
      if (el.textContent.trim().startsWith('Auto + Ship')) {
        el.textContent = el.textContent.replace('Auto + Ship', 'Autoship');
      }
    });
  }

  const observer = new MutationObserver(renameAutoship);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      renameAutoship();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    renameAutoship();
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();


// Loox Slider arrow color change of SVG icon
setTimeout(() => {
  document.querySelectorAll("loox-dynamic-carousel-widget").forEach((widget) => {
    const shadow = widget.shadowRoot;
    if (!shadow) return;

    const style = document.createElement("style");
    style.textContent = `
      .swiper-button-prev svg,
      .swiper-button-next svg {
        width: 24px;
        height: 24px;
        fill: rgb(51, 51, 51) !important;
      }
    `;

    shadow.appendChild(style);
  });
}, 12000);



document.querySelectorAll('input[name^="brightside-purchase-type"]').forEach(function (input) {
  input.addEventListener('change', function () {
    var card = this.closest('.soda-card');
    if (!card) return;

    var isOneTime = this.value === 'onetime' && this.checked;
    card.querySelectorAll('.pack-selector .pack-option').forEach(function (opt) {
      opt.classList.toggle('hide-free-shipping', isOneTime);
    });
  });
});

 


function updateVariantLabel() {
  const input = document.querySelector(".brightside-purchase-option--onetime input");
  const labels = document.querySelectorAll(".variant-option__button-label");

  if (!input || !labels.length) return;

  labels.forEach((label) => {
    label.classList.toggle("hide-free-shipping", input.checked);
  });
}

document.addEventListener("change", updateVariantLabel);
document.addEventListener("DOMContentLoaded", updateVariantLabel);






/* Header Menu js 17-08 */

document.addEventListener('click', function (event) {
  const button = event.target.closest('.header-menu-overlay__submenu-toggle');

  if (!button) return;

  const submenuId = button.getAttribute('aria-controls');
  const submenu = document.getElementById(submenuId);

  if (!submenu) {
    console.warn('Submenu not found:', submenuId);
    return;
  }

  const isExpanded = button.getAttribute('aria-expanded') === 'true';

  button.setAttribute('aria-expanded', String(!isExpanded));
  submenu.hidden = isExpanded;
});


 document.addEventListener('DOMContentLoaded', function () {
    function disablePromoTransform() {
      if (window.innerWidth <= 767) {
        document.querySelectorAll('.promo-banner').forEach(function (banner) {
          banner.style.setProperty('transform', 'none', 'important');
          banner.style.setProperty('transition', 'none', 'important');
        });
      }
    }

    // Initial fix
    disablePromoTransform();

    // Fix if the theme's JS changes the transform again
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'style'
        ) {
          disablePromoTransform();
        }
      });
    });

    document.querySelectorAll('.promo-banner').forEach(function (banner) {
      observer.observe(banner, {
        attributes: true,
        attributeFilter: ['style']
      });
    });

    // Handle resize
    window.addEventListener('resize', disablePromoTransform);
  });